import React from "react";
import PropTypes from "prop-types";
import {FaRegFilePdf, FaRegFileAudio, FaFileAlt} from "react-icons/fa";


function File(props) {

  var title = "Navigate to " + props.name
    return (
      <tr className="file">
        <td>
       <a data-itemtype="Document" target="_blank"  rel="noreferrer"  title={title}  href={props.LinkToItem}>{props.name.endsWith('.pdf') ? <FaRegFilePdf />: props.name.endsWith('.mp4') || props.name.endsWith('.mp3') ? <FaRegFileAudio /> : <FaFileAlt />} {props.name}</a> 
       </td>
      </tr>
    );
  }

File.propTypes = {
    Name: PropTypes.string.isRequired,
    LinkToItem:PropTypes.string
};
export default File;